/* eslint-disable import/prefer-default-export */
import React from 'react';
import { Form, Icon, Input, Button } from 'antd';

const FormItem = Form.Item;

const OTP_RULES_EMAIL_SMS = [{ required: true, message: 'One-time passcode is required.' }];

const OTP_RULES_TOTP = [
  { required: true, message: 'Enter the 6-digit code from your authenticator app.' },
  { pattern: /^\d{6}$/, message: 'The code must be exactly 6 digits.' },
];

/**
 * Second step of login: enter OTP (email/SMS) or TOTP from an authenticator app.
 */
export function MFAFormVerifyStep({
  isTotpLogin,
  authenticatorLabel,
  getFieldDecorator,
  codeInputRef,
  loginRequest,
  onSubmit,
  onResendOtp,
}) {
  return (
    <Form onSubmit={onSubmit} className={`login-form ${isTotpLogin ? 'login-form--totp' : ''}`}>
      <div className={isTotpLogin ? 'login-mfa-verify-card login-mfa-verify-card--totp' : ''}>
        <h3 className="login-mfa-verify-title">{isTotpLogin ? 'Enter 6-digit code' : 'Verification code'}</h3>
        {isTotpLogin && (
          <p className="login-authenticator-hint">
            Use the code shown <strong>now</strong> in {authenticatorLabel}. If verification fails, wait for the next
            code and try again. Do not use an old code.
          </p>
        )}
        <FormItem className={isTotpLogin ? 'login-mfa-otp-item login-mfa-otp-item--totp' : ''}>
          {getFieldDecorator('otpCode', {
            rules: isTotpLogin ? OTP_RULES_TOTP : OTP_RULES_EMAIL_SMS,
            getValueFromEvent: isTotpLogin
              ? (e) => e.target.value.replace(/\D/g, '').slice(0, 6)
              : (e) => e.target.value,
          })(
            isTotpLogin ? (
              <Input
                size="large"
                placeholder="000000"
                disabled={loginRequest}
                autoComplete="one-time-code"
                inputMode="numeric"
                name="one-time-code"
                ref={codeInputRef}
                maxLength={6}
                className="login-mfa-otp-input login-mfa-otp-input--totp"
                aria-label="6-digit authenticator code"
              />
            ) : (
              <Input
                prefix={<Icon type="lock" style={{ fontSize: 13 }} />}
                placeholder="Code"
                disabled={loginRequest}
                autoComplete="one-time-code"
                inputMode="numeric"
                pattern="[0-9]*"
                ref={codeInputRef}
                maxLength={6}
              />
            ),
          )}
        </FormItem>
        <FormItem>
          <Button
            type="primary"
            htmlType="submit"
            disabled={loginRequest}
            loading={loginRequest}
            className="login-form-btn"
          >
            {loginRequest ? 'Verifying…' : 'Verify and continue'}
          </Button>
          {!isTotpLogin && (
            <Button type="default" disabled={loginRequest} className="login-form-btn" onClick={onResendOtp}>
              Resend code
            </Button>
          )}
        </FormItem>
        {isTotpLogin && (
          <p className="login-authenticator-recovery">
            <a href="/authenticator-recovery">Can&apos;t use your authenticator?</a>
          </p>
        )}
      </div>
    </Form>
  );
}
